import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import Grid from '../../components/Grid'
import Input from '../../components/Input'
import Label from '../../components/Label'
import MedicationDisplay from '../../components/MedicationDisplay'
import Prompts from '../../components/Prompts'
import Row from '../../components/Row'
import Select from '../../components/Select'
import Text from '../../components/Text'
import Toggle from '../../components/Toggle'
import patient from '../../stores/patient'

const TextArea = styled.textarea`
  background: var(--off-white);
  padding: 0.75rem;
  line-height: 125%;
  overflow-y: auto;
  resize: none;
  min-height: 10rem;
  flex: 1;
  width: 100%;
  border: 1px solid transparent;
  display: block;
  &:focus {
    border: 1px solid var(--blue);
  }
`

const MedicationButton = styled.button`
  background: transparent;
  cursor: pointer;
  flex: 1;
  display: flex;
  border: 2px solid ${props => props.active ? 'var(--purple)' : 'var(--gray)'};
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  padding: 0.75rem;
  text-align: left;
  align-items: center;
  color: #000;
  box-shadow: 0 0 5px ${props => props.active ? 'var(--purple)' : 'transparent'};
  transition: all 0.2s;
`

const RemoveButton = styled.button`
  background: transparent;
  cursor: pointer;
  color: var(--gray);
  width: 100%;
  font-size: 1.1rem;
  &:hover {
    color: var(--red);
  }
`

@observer
export default class PlanForm extends Component {
  render() {
    const { index } = this.props

    return (
      <Card>
        <Card.Pad>
          <Prompts withBottomMargin>
            <Prompts.R small str="prose.takeYourFirstDose" />
          </Prompts>
          <Grid>
            <Grid.HalfCell>
              <Input
                name="time"
                label="titles.time"
                value={patient.fields.plans[index].time}
                onChange={event => patient.setPlanField(index, event)}
              />
              <Row style={{ margin: '0' }}>
                <Row.Cell>
                  <Toggle radio
                    color="purple"
                    checked={patient.fields.plans[index].timePeriod === 'AM'}
                    str="titles.am"
                    onToggle={() => patient.setPlanTimePeriod(index, 'AM')}
                  />
                </Row.Cell>
                <Row.Cell>
                  <Toggle radio
                    color="purple"
                    checked={patient.fields.plans[index].timePeriod === 'PM'}
                    str="titles.pm"
                    onToggle={() => patient.setPlanTimePeriod(index, 'PM')}
                  />
                </Row.Cell>
              </Row>
              <Select
                label="titles.location"
                name="location"
                value={patient.fields.plans[index].location}
                onChange={event => patient.setPlanField(index, event)}
              >
                <Select.Options choices="location" />
              </Select>

            </Grid.HalfCell>
            <Grid.HalfCell>
              <Label str="titles.descriptionOfRoutine" />
              <TextArea
                name="routine"
                value={patient.fields.plans[index].routine}
                onChange={event => patient.setPlanField(index, event)}
              />
              {patient.fields.plans[index].location === 'OTHER' && <div
                style={{
                  fontSize: '0.9em',
                  opacity: '0.5',
                  textAlign: 'center',
                  lineHeight: '1.5',
                  marginTop: '0.5rem',
                }}
              >
                <i className="fa fa-info-circle" />&nbsp;&nbsp;Remember to describe medication location
              </div>}
            </Grid.HalfCell>
          </Grid>
        </Card.Pad>
        {patient.hasMedications &&
          <Fragment>
            <Card.Divider />
            <Card.Pad>
              <Label str="titles.selectMedicationsPlan" style={{ textAlign: 'center', marginBottom: '1rem' }} />
              <Grid>
                {patient.fields.medications.map((m, i) => (
                  <Grid.HalfCell key={i}>
                    <MedicationButton
                      active={patient.fields.plans[index].medications.includes(m.prescription)}
                      onClick={() => patient.togglePlanMedication(index, m.prescription)}
                    >
                      <MedicationDisplay medication={m} />
                    </MedicationButton>
                  </Grid.HalfCell>
                ))}
              </Grid>
            </Card.Pad>
          </Fragment>
        }
        <Card.Divider />
        <Card.Pad>
          <RemoveButton onClick={() => patient.removePlan(index)}>
            <Text str="titles.removePlan" />
          </RemoveButton>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Plan/PlanForm.js